var map = {
	"./broadband.svg": "5e45",
	"./dth.svg": "7071",
	"./electricity.svg": "4059",
	"./gas.svg": "5ddc",
	"./placeholder.svg": "59a1",
	"./postpaid.svg": "d465",
	"./prepaid.svg": "6840",
	"./satellite-dish.svg": "1d02",
	"./stv.svg": "448e",
	"./water.svg": "569c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";